// extracted by mini-css-extract-plugin
export default {"sectionWrap":"xMgcXS","mobile":"Ge_XE2","section":"w9Tgar","sectionHeadline":"SooYe4"};